// Removed framer-motion for bundle size optimization - using CSS animations instead

export default function Hero() {
  const scrollToRSVP = () => {
    const rsvpSection = document.getElementById('rsvp')
    if (rsvpSection) {
      rsvpSection.scrollIntoView({ behavior: 'smooth' })
    }
  }
  return (
    <div className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* 背景画像 */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        <img
          src="/images/228.webp"
          alt="Kenty & Mika"
          className="w-full h-full object-cover animate-pulse"
          style={{ 
            animation: 'hero-zoom 20s ease-in-out infinite alternate',
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-pastel-pink/40 via-transparent to-pastel-blue/40" />
      </div>

      {/* コンテンツ */}
      <div className="relative z-10 text-center px-4 w-full max-w-screen-sm mx-auto">
        <h1 className="text-5xl sm:text-6xl md:text-8xl font-fairy mb-4 text-white drop-shadow-lg">
          <span 
            className="block font-dancing py-2 animate-slide-in-right"
            style={{ 
              animation: 'slide-in-right 2.5s ease-in-out 0.2s both',
            }}
          >
            Kenty & Mika
          </span>
        </h1>

        <p className="text-2xl sm:text-2xl md:text-3xl font-fairy text-white mb-8 drop-shadow">
          <span 
            className="block font-dancing"
            style={{ 
              animation: 'slide-in-right 2s ease-in-out 1.5s both',
            }}
          >
            2025.11.02 Sun
          </span>
        </p>

        <div 
          className="animate-fade-in-up"
          style={{ 
            animation: 'fade-in-up 0.8s ease-out 3s both',
          }}
        >
          <div className="text-base sm:text-lg md:text-xl font-fairy text-white drop-shadow mb-4">
            <span 
              className="block font-fairy"
              style={{ 
                animation: 'slide-in-right 2.5s ease-in-out 2.5s both',
              }}
            >
              琉球ホテル＆リゾート 名城ビーチ
            </span>
          </div>

          <div className="relative inline-block mt-60">
            <button
              onClick={scrollToRSVP}
              className="fairy-button text-base sm:text-lg md:text-xl relative z-10 hover:scale-105 active:scale-95 transition-transform duration-200"
            >
              出欠のご連絡はこちら
            </button>

            {/* chanya */}
            <img
              src="/cats/chanyaArm.webp"
              alt="Cat"
              className="absolute left-4 md:w-32 md:h-32 object-contain z-20 pointer-events-none"
              style={{ 
                top: '-5rem', 
                height: '85px', 
                width: '85px',
                animation: 'fade-in-left 0.8s ease-out 3.5s both',
              }}
            />

            {/* chelsea */}
            <img
              src="/cats/chelseaArm.webp"
              alt="Cat"
              className="absolute right-4 w-24 h-24 object-contain z-20 pointer-events-none"
              style={{ 
                top: '-4.8rem',
                animation: 'fade-in-right 0.8s ease-out 3.7s both',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
